/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.dinghy', {
            parent: 'board.dinghy',
            url: '/dinghies?sort',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'dinghy@board.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghies.html',
                    controller: 'DinghyBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                sort: {
                    value: 'type,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: 1,
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: null
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.dinghy.new', {
            parent: 'board.dinghy.dinghy',
            url: '/new',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.dinghy.home.createLabel'
            },
            views: {
                'dinghyDetail@board.dinghy.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        comment: null,
                        available: true,
                        type: null,
                        active: true,
                        dateDeactivated: null,
                        id: null
                    };
                }
            }
        })
        .state('board.dinghy.dinghy.edit', {
            parent: 'board.dinghy.dinghy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_BOARD', 'ROLE_DINGHY'],
                pageTitle: 'askApp.dinghy.home.editLabel'
            },
            views: {
                'dinghyDetail@board.dinghy.dinghy': {
                    templateUrl: 'app/board/dinghy/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DinghyBoard', function($stateParams, DinghyBoard) {
                    return DinghyBoard.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
